import { addSeconds, areIntervalsOverlapping } from 'date-fns'

import { ScheduleShift } from '@/entities/Shift/Shift'
import { getEndOfWorkDay, getStartOfWorkDay } from '@/helpers/date'

export function doesShiftFallOnWorkDay(shift: ScheduleShift, day: Date): boolean {
    return areIntervalsOverlapping(
        {
            start: new Date(shift.period.start),
            end: addSeconds(new Date(shift.period.start), 1),
        },
        {
            start: getStartOfWorkDay(day),
            end: getEndOfWorkDay(day),
        },
    )
}
